import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../../../../FormLegacy/FormFieldsV2/TextAreaField'

const TextToSpeechTab = ({ onChange = () => {}, value }) => {
  const { t } = useTranslation(['chat'])
  return (
    <div className="tab-content text-to-speech-tab">
      <TextAreaField
        name="text"
        placeholder={t('chat:manageVoicemail.greetingTextPlaceholder')}
        label={t('chat:manageVoicemail.greetingTextLabel')}
        maxLength={500}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}

TextToSpeechTab.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default TextToSpeechTab
